export const SORT_ASC = 0
export const SORT_DESC = 1
export const SORT_RANDOM = 2



// WEBPACK FOOTER //
// ./src/sortTypes.js